import styled from "styled-components";
import { FC } from "react";

import { Icon } from "../../Icon";
import { SelectComponentProps } from "./types";

const StyledClearIndicator = styled.div`
  display: flex;
  padding: 0px 8px;
  align-items: center;
`;

type ClearIndicatorProps = SelectComponentProps["ClearIndicator"];

export const ClearIndicator: FC<ClearIndicatorProps> = ({ innerProps }) => (
  <StyledClearIndicator data-testid="ClearIndicator">
    <Icon
      iconName="close"
      iconSize="small"
      variant="INACTIVE"
      plain
      {...innerProps}
    />
  </StyledClearIndicator>
);
